import { OrderTrackingAnalyticsTotalsSnapshotSchema } from "@redotech/redo-analytics-common/analytics";
import * as z from "zod";

export const getOrderTrackingAnalytics = {
  name: "getOrderTrackingAnalytics" as const,
  input: z.object({
    numUnits: z.number().positive(),
    startDate: z.date(),
    pageSize: z.number().positive().optional(),
    pageNumber: z.number().nonnegative().optional(),
  }),
  output: z.object({
    current: z.array(OrderTrackingAnalyticsTotalsSnapshotSchema),
    previous: z.array(OrderTrackingAnalyticsTotalsSnapshotSchema),
    totalCount: z.number().optional(),
  }),
};
